import EventableObject from './eventable_object';

export default class Viewport extends EventableObject {
  constructor(source) {
    super();

    this.source = source;

    this.canvas = document.getElementById('viewport');
    this.context = this.canvas.getContext('2d');

    this.canvas.width = this.canvas.clientWidth;
    this.canvas.height = this.canvas.clientHeight;
    this.width = this.canvas.clientWidth;
    this.height = this.canvas.clientHeight;

    // (0; 0) - центр канваса
    this.offset = {
      x: 0,
      y: 0
    }
    this.scale = 1.0;
    this.selection = null; // projected

    this.maxScale = 4.0;
    this.minScale = 0.05;
    this.scaleSpeed = 0.05;

    this.mouseState = {
      down: false,

      move: null,
      select: null
    };

    this.background = 'rgb(30, 30, 30)';
    this.interlace = ((size, color1, color2) => {
      let proto = document.createElement("canvas").getContext("2d");
      proto.canvas.width = size * 2;
      proto.canvas.height = size * 2;
      proto.fillStyle = color1; // top-left
      proto.fillRect(0, 0, size, size);
      proto.fillStyle = color2; // top-right
      proto.fillRect(size, 0, size, size);
      proto.fillStyle = color2; // bottom-left
      proto.fillRect(0, size, size, size);
      proto.fillStyle = color1; // bottom-right
      proto.fillRect(size, size, size, size);
      let pattern = proto.createPattern(proto.canvas, "repeat");
      pattern.data = proto.canvas.toDataURL();
      return pattern;
    })(8, '#fff', '#eee');

    this.bindEvents();
    this.render();
  }

  saveState() {
    return {
      offset: this.offset,
      scale: this.scale,
      selection: this.selection
    };
  }

  restoreState(state) {
    if (!state) {
      this.offset = {
        x: 0,
        y: 0
      };
      this.scale = 1.0;
      this.selection = null;
      this.autoScale('start');
    } else {
      this.offset = state.offset;
      this.scale = state.scale;
      this.selection = state.selection;
    }

    this.update();

    this.triggerEvent('update-scale', this.scale);
    this.triggerEvent('select', this.selection);
    this.render();
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      let diff = {
        width: this.width - this.canvas.clientWidth,
        height: this.height - this.canvas.clientHeight
      }

      this.canvas.width = this.canvas.clientWidth;
      this.canvas.height = this.canvas.clientHeight;
      this.width = this.canvas.clientWidth;
      this.height = this.canvas.clientHeight;

      this.render();
    });

    this.canvas.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    this.canvas.addEventListener('wheel', (e) => {
      e.preventDefault();

      let delta = e.deltaY > 0 ? -1 : +1;
      let prevScale = this.scale;

      let prevPos = this.projectCoords(e.offsetX, e.offsetY);

      this.scale = Math.min(this.maxScale, Math.max(this.minScale,
        this.scale + delta * this.scaleSpeed
      ));

      let currPos = this.projectCoords(e.offsetX, e.offsetY);

      this.offset.x += (currPos.x - prevPos.x) * this.scale;
      this.offset.y += (currPos.y - prevPos.y) * this.scale;

      this.update();

      this.triggerEvent('update-scale', this.scale);
      this.triggerEvent('mousewheel', e);
    });

    let detectMouseAction = (e) => {
      switch(e.which) {
        case 1: // left
          return 'select';
        case 3: // right
          return 'move';
      }
      return null;
    }

    this.canvas.addEventListener('mousedown', (e) => {
      e.preventDefault();

      let action = detectMouseAction(e);
      if (!action)
        return;

      this.mouseState.down = 1;
      this.mouseState[action] = {
        start: {
          x: e.offsetX,
          y: e.offsetY
        },
        projectedStart: this.projectCoords(e.offsetX, e.offsetY),

        prev: {
          x: e.offsetX,
          y: e.offsetY
        },

        steps: 0 // кол-во полученных событий mousemove
      }
    });

    // сначала обработчик от канваса, потом - глобальный
    // в канвасом отслеживаем координаты нажатия
    // в глобальном - чистим переменную

    this.canvas.addEventListener('mouseup', (e) => {
      if (!this.mouseState.down)
        return;

      if (this.mouseState.select) {
        if (this.selection && this.mouseState.select.steps > 2 && this.selection.right - this.selection.left > 0 && this.selection.bottom - this.selection.top > 0) {
          this.triggerEvent('select', this.selection);
        } else {
          let proj = this.mouseState.select.projectedStart;

//          if (!this.selection || (proj.x >= this.selection.left && proj.y >= this.selection.top && proj.x <= this.selection.right && proj.y <= this.selection.bottom)) {
            this.triggerEvent('click', {
              x: proj.x|0,
              y: proj.y|0
            });
//          } else {
//            this.selection = null;
//            this.triggerEvent('select', this.selection);
//          }
        }
      }
    });

    window.addEventListener('mouseup', (e) => {
      if (!this.mouseState.down)
        return;

      e.preventDefault();

      for (let key of Object.keys(this.mouseState)) {
        this.mouseState[key] = null;
      }

      this.mouseState.down = false;
    });

    this.canvas.addEventListener('mouseleave', (e) => {
      this.triggerEvent('mouseleave');
    });

    this.canvas.addEventListener('mousemove', (e) => {
      e.preventDefault();

      if (!this.mouseState.down) {
        let proj = this.projectCoords(e.offsetX, e.offsetY);
        if (proj.x >= 0 && proj.y >= 0 && proj.x < this.source.width && proj.y < this.source.height) {
          this.triggerEvent('mousemove', {
            x: proj.x|0,
            y: proj.y|0
          });
        } else {
          this.triggerEvent('mousemove-out');
        }
      }

      if (this.mouseState.move) {
        //cursor = 'move';

        let delta = {
          x: this.mouseState.move.prev.x - e.offsetX,
          y: this.mouseState.move.prev.y - e.offsetY
        }

        this.offset.x -= delta.x;
        this.offset.y -= delta.y;

        this.mouseState.move.prev = {
          x: e.offsetX,
          y: e.offsetY
        }

        this.mouseState.move.steps += 1;
      }

      if (this.mouseState.select) {
        this.mouseState.select.steps += 1;

        if (this.mouseState.select.steps > 2) {
          let proj = this.projectCoords(e.offsetX, e.offsetY);

          this.selection = {
            left: Math.max(0, Math.min(this.source.width - 1, proj.x, this.mouseState.select.projectedStart.x))|0,
            top: Math.max(0, Math.min(this.source.height - 1, proj.y, this.mouseState.select.projectedStart.y))|0,
            right: Math.min(this.source.width - 1, Math.max(0, proj.x, this.mouseState.select.projectedStart.x))|0,
            bottom: Math.min(this.source.height - 1, Math.max(0, proj.y, this.mouseState.select.projectedStart.y))|0
          }
        }
      }

      //this.canvas.style.cursor = cursor;
      this.update();
    });
  }

  // в пространстве оригинального изображения
  projectCoords(x, y) {
    if (y === undefined) {
      y = x.y;
      x = x.x;
    }

    return {
      x: (((x - this.offset.x - this.width * 0.5) / this.scale) + this.source.width * 0.5)|0,
      y: (((y - this.offset.y - this.height * 0.5) / this.scale) + this.source.height * 0.5)|0
    }
  }

  // в отображаемом пространстве
  unprojectCoords(x, y) {
    if (y === undefined) {
      y = x.y;
      x = x.x;
    }

    return {
      x: (x - this.source.width * 0.5) * this.scale + this.offset.x + this.width * 0.5,
      y: (y - this.source.height * 0.5) * this.scale + this.offset.y + this.height * 0.5
    }
  }

  autoScale(mode) {
    if (!mode)
      mode = 'fit';

    if (mode == 'fit') {
      this.scale = Math.min(this.width / this.source.width, this.height / this.source.height);
      this.offset.x = 0;
      this.offset.y = 0;
    }
    else if (mode == 'fit width') {
      this.scale = this.width / this.source.width;
      this.offset.x = 0;
      this.offset.y = 0;
    }
    else if (mode == 'fit height') {
      this.scale = this.height / this.source.height;
      this.offset.x = 0;
      this.offset.y = 0;
    }
    else if (mode == '100%') {
      this.scale = 1.0;
      this.offset.x = 0;
      this.offset.y = 0;
    }
    else if (mode == 'start') {
      this.scale = Math.min(1.0, Math.max(this.width / this.source.width, this.height / this.source.height));
      if (this.source.width * this.scale < this.width) {
        this.offset.x = 0;
      } else {
        this.offset.x = (this.source.width * this.scale - this.width) * 0.5;
      }
      if (this.source.height * this.scale < this.height) {
        this.offset.y = 0;
      } else {
        this.offset.y = (this.source.height * this.scale - this.height) * 0.5;
      }
    }

    this.update();

    this.triggerEvent('update-scale', this.scale);
  }

  setScale(value) {
    this.scale = value;
    this.update();

    this.triggerEvent('update-scale', this.scale);
  }

  update() {
    this.scale = Math.min(this.maxScale, Math.max(this.minScale, this.scale));

    let margin = Math.min(this.width, this.height) * 0.25;

    this.offset.x = Math.max(
      -(this.width + this.source.width * this.scale) * 0.5 + margin,
      Math.min(
        (this.width + this.source.width * this.scale) * 0.5 - margin,
        this.offset.x
      )
    );

    this.offset.y = Math.max(
      -(this.height + this.source.height * this.scale) * 0.5 + margin,
      Math.min(
        (this.height + this.source.height * this.scale) * 0.5 - margin,
        this.offset.y
      )
    );

    this.render();
  }

  moveToSelection() {
    if (!this.selection)
      return;

    let margin = Math.min(this.width, this.height) * 0.25;

    this.offset.x = Math.max(
      -(this.width + this.source.width * this.scale) * 0.5 + margin + (this.source.width - this.selection.right) * this.scale,
      Math.min(
        (this.width + this.source.width * this.scale) * 0.5 - margin - this.selection.left * this.scale,
        this.offset.x
      )
    );

    this.offset.y = Math.max(
      -(this.height + this.source.height * this.scale) * 0.5 + margin + (this.source.height - this.selection.bottom) * this.scale,
      Math.min(
        (this.height + this.source.height * this.scale) * 0.5 - margin - this.selection.top * this.scale,
        this.offset.y
      )
    );

    this.update();
  }

  render() {
    let ctx = this.context;

    ctx.imageSmoothingEnabled       = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.mozImageSmoothingEnabled    = false;
    ctx.msImageSmoothingEnabled     = false;
    ctx.oImageSmoothingEnabled      = false;

    ctx.fillStyle = this.background;
    ctx.fillRect(0, 0, this.width, this.height);

    if (this.source.width == 0 || this.source.height == 0)
      return;

    let topLeft = this.unprojectCoords(0, 0);
    let bottomRight = this.unprojectCoords(this.source.width, this.source.height);

    topLeft.x = Math.round(topLeft.x);
    topLeft.y = Math.round(topLeft.y);
    bottomRight.x = Math.round(bottomRight.x);
    bottomRight.y = Math.round(bottomRight.y);

    ctx.save();
    ctx.fillStyle = this.interlace;
    ctx.shadowColor = '#000';
    ctx.shadowBlur = 3;
    ctx.fillRect(topLeft.x, topLeft.y, bottomRight.x - topLeft.x, bottomRight.y - topLeft.y);
    ctx.restore();

    ctx.drawImage(this.source, topLeft.x, topLeft.y, bottomRight.x - topLeft.x, bottomRight.y - topLeft.y);

    if (this.selection) {
      let selectionTopLeft = this.unprojectCoords(this.selection.left, this.selection.top);
      let selectionBottomRight = this.unprojectCoords(this.selection.right, this.selection.bottom);

      selectionTopLeft.x = Math.round(selectionTopLeft.x);
      selectionTopLeft.y = Math.round(selectionTopLeft.y);
      selectionBottomRight.x = Math.round(selectionBottomRight.x);
      selectionBottomRight.y = Math.round(selectionBottomRight.y);

      ctx.save();
      ctx.fillStyle = 'rgba(0, 0, 0, 0.8)';
      ctx.fillRect(topLeft.x, topLeft.y, bottomRight.x - topLeft.x, selectionTopLeft.y - topLeft.y);
      ctx.fillRect(topLeft.x, selectionTopLeft.y, selectionTopLeft.x - topLeft.x, selectionBottomRight.y - selectionTopLeft.y);
      ctx.fillRect(selectionBottomRight.x, selectionTopLeft.y, bottomRight.x - selectionBottomRight.x, selectionBottomRight.y - selectionTopLeft.y);
      ctx.fillRect(topLeft.x, selectionBottomRight.y, bottomRight.x - topLeft.x, bottomRight.y - selectionBottomRight.y);
      ctx.shadowColor = '#000';
      ctx.shadowBlur = 3;
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
      ctx.lineWidth = 1;
      ctx.strokeRect(selectionTopLeft.x, selectionTopLeft.y, selectionBottomRight.x - selectionTopLeft.x, selectionBottomRight.y - selectionTopLeft.y);
      ctx.restore();
    }
  }
}
